(function () {
  if (!document.querySelector(".section-l4-page-base")) {
    return;
  }

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  function getLeadMeta(widget, form) {
    var location =
      (form && form.getAttribute("data-l4-lead-location")) ||
      (widget && widget.getAttribute("data-l4-lead-location")) ||
      "";
    var tag =
      (form && form.getAttribute("data-l4-lead-tag")) ||
      (widget && widget.getAttribute("data-l4-lead-tag")) ||
      "";
    return {
      l4_lead_location: location,
      l4_lead_tag: tag,
      l4_lead_form_id: form && form.id ? form.id : ""
    };
  }

  function trackL4Lead(action, widget, form, extra) {
    var detail = Object.assign(getLeadMeta(widget, form), extra || {});
    var dataLayerEvent = "l4_lead_" + action;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: dataLayerEvent }, detail));
    } catch (error) {}

    try {
      document.dispatchEvent(
        new CustomEvent("l4:lead:" + action, {
          detail: detail
        })
      );
    } catch (error) {}
  }

  function bindLeadWidgets(root) {
    root = root || document;
    var widgets = Array.prototype.slice.call(root.querySelectorAll("[data-l4-lead-widget]"));

    if (!widgets.length) {
      return;
    }

    function showSuccessOnWidget(widget) {
      if (!widget) {
        return;
      }

      var form = widget.querySelector(".lm-lead-form");
      var success = widget.querySelector("[data-lead-success]");

      widget.classList.add("is-success");

      if (form) {
        clearInvalid(form);
        form.hidden = true;
        form.setAttribute("aria-hidden", "true");
      }

      if (success) {
        success.hidden = false;
        success.removeAttribute("aria-hidden");
      }
    }

    function showSuccessEverywhere() {
      Array.prototype.slice
        .call(document.querySelectorAll("[data-l4-lead-widget]"))
        .forEach(showSuccessOnWidget);
    }

    widgets.forEach(function (widget) {
      if (widget.classList.contains("is-success") || widget.hasAttribute("data-l4-lead-subscribed")) {
        showSuccessOnWidget(widget);
      }
    });

    var forms = widgets
      .map(function (widget) {
        return widget.querySelector(".lm-lead-form");
      })
      .filter(function (form) {
        return form && !form.hidden && form.querySelector("input[type='email']");
      });

    forms.forEach(function (form) {
      if (form.dataset.l4LeadBound === "1") {
        return;
      }
      form.dataset.l4LeadBound = "1";

      var widget = form.closest("[data-l4-lead-widget]");
      var input = form.querySelector("input[type='email']");
      if (!input) {
        return;
      }

      input.addEventListener("input", function () {
        if (form.classList.contains("is-invalid")) {
          clearInvalid(form);
        }
      });

      form.addEventListener("submit", function (event) {
        event.preventDefault();

        var value = input.value.trim();
        var button = form.querySelector("button[type='submit']");

        if (!emailPattern.test(value)) {
          setInvalid(form);
          trackL4Lead("error", widget, form, { l4_lead_error_type: "invalid_email" });
          input.focus();
          return;
        }

        trackL4Lead("submit", widget, form);

        if (!isShopifyCustomerForm(form)) {
          trackL4Lead("success", widget, form);
          showSuccessEverywhere();
          return;
        }

        if (button) {
          button.disabled = true;
        }

        submitShopifyCustomerForm(form)
          .then(function () {
            trackL4Lead("success", widget, form);
            showSuccessEverywhere();
          })
          .catch(function () {
            if (button) {
              button.disabled = false;
            }
            setInvalid(form);
            trackL4Lead("error", widget, form, { l4_lead_error_type: "request_failed" });
            input.focus();
          });
      });
    });
  }

  function isShopifyCustomerForm(form) {
    return Boolean(form.querySelector("input[name='form_type'][value='customer']"));
  }

  async function submitShopifyCustomerForm(form) {
    var response = await fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      credentials: "same-origin",
      headers: {
        Accept: "text/html"
      }
    });

    if (!response.ok) {
      throw new Error("Shopify customer form request failed.");
    }
  }

  function setInvalid(form) {
    form.classList.add("is-invalid");
    var input = form.querySelector("input[type='email']");
    if (input) {
      input.setAttribute("aria-invalid", "true");
    }
  }

  function clearInvalid(form) {
    form.classList.remove("is-invalid");
    var input = form.querySelector("input[type='email']");
    if (input) {
      input.removeAttribute("aria-invalid");
    }
  }

  bindLeadWidgets(document);

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target) {
      bindLeadWidgets(event.target);
    }
  });
})();
